
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { useState, useEffect } from "react";
import { useStockItems } from "@/hooks/useStockItems";
import { StockContent } from "@/components/stock/StockContent";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useInventoryState } from "@/hooks/useInventoryState";
import { toast } from "sonner";
import { AddProductDialog } from "@/components/interface/AddProductDialog";
import { LoadingState } from "@/components/stock/states/LoadingState";
import { EmptyState } from "@/components/stock/states/EmptyState";
import { supabase } from "@/integrations/supabase/client";

const Stock = () => {
  const {
    data: stockItems,
    isLoading,
    error,
    refetch
  } = useStockItems();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Toutes les catégories");
  const {
    isInventoryActive,
    setIsInventoryActive
  } = useInventoryState();
  const [isAddProductDialogOpen, setIsAddProductDialogOpen] = useState(false);
  
  // Mettre en place les mises à jour en temps réel
  useEffect(() => {
    console.log("Setting up realtime subscription for stock items");
    const channel = supabase.channel('stock-changes').on('postgres_changes', {
      event: '*',
      schema: 'public',
      table: 'stock_items'
    }, payload => {
      console.log("Received realtime update:", payload);
      refetch();
    }).subscribe();
    return () => {
      console.log("Cleaning up realtime subscription");
      supabase.removeChannel(channel);
    };
  }, [refetch]);
  
  if (error) {
    toast.error("Une erreur est survenue lors du chargement du stock");
  }
  
  const handleAddProduct = () => {
    refetch();
    setIsAddProductDialogOpen(false);
    toast.success("Produit ajouté avec succès");
  };
  
  const filteredItems = stockItems?.filter(item => {
    if (!item) return false;
    const itemName = item.data?.Race || item.data?.name || "";
    return itemName.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <DashboardLayout userType="owner" isInventoryActive={isInventoryActive}>
      <div className="space-y-6">
        <PageTitle title="Gestion du stock" subtitle="Gérez votre inventaire et suivez vos produits" />
        
        {isLoading ? (
          <LoadingState />
        ) : !stockItems || stockItems.length === 0 ? (
          <EmptyState onAddProduct={() => setIsAddProductDialogOpen(true)} />
        ) : (
          <TooltipProvider>
            <div className="space-y-4">
              <StockContent 
                stockItems={filteredItems || []} 
                searchQuery={searchQuery} 
                setSearchQuery={setSearchQuery} 
                selectedCategory={selectedCategory} 
                setSelectedCategory={setSelectedCategory} 
                refetch={refetch} 
                onInventoryStateChange={setIsInventoryActive} 
              />
            </div>
          </TooltipProvider>
        )}

        <AddProductDialog 
          isOpen={isAddProductDialogOpen} 
          onOpenChange={setIsAddProductDialogOpen} 
          onSubmit={handleAddProduct} 
        />
      </div>
    </DashboardLayout>
  );
};

export default Stock;
